module.exports = __webpack_public_path__ + "img/care_dokter_logo.6da53cb0.png";